"use strict";

import angular from "angular";
import "./analysis-plus-dialog.scss";
import { UserDataAdapter } from "../../../../../../presentation/adpters/UserDataAdapter";
import { RequestAnalysisPlus } from "../../../../../../presentation/services/RequestActiveAnalysisPlus/RequestActiveAnalysisPlus";
import { Accounting } from "../../../../../../gateway/Accounting/Accounting";
import {
    activateAnalysisPlusDialogTemplate,
    applyLicensesDialogTemplate,
    requestConfirmAnalysisPlusDialogTemplate,
    requestLicensesDialogTemplate
} from "../../dashboards.dialog-templates";

class AnalysisPlusDialogCtrl {
    Accounting = new Accounting();

    optionsButton = {
        activate: { label: "Ativar", activate: true },
        requestLicence: { label: "Solicitar licença", requestLicence: true }
    };
    buttonText = { label: "Ativar", activate: true };
    analysisPlusCount = {
        maxCompanies: 0,
        currentCompanies: 0
    };
    constructor($mdDialog, DSNDialogService, locals, toast) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.toast = toast;

        this.user = new UserDataAdapter().user();

        this.RequestAnalysisPlus = new RequestAnalysisPlus({
            DSNDialogService: this.DSNDialogService,
            mdDialog: $mdDialog,
            toast: this.toast
        });
    }

    $onInit() {
        this._onInitView();
    }

    async _onInitView() {
        this.loading = true;
        this._verifyAnalysisPlus();
        await this._onVerifyCountCompanies();
        this.loading = false;
    }

    async _onVerifyCountCompanies() {
        const isAdmin = this.user.roles.some((r) =>
            ["Contabilidade"].includes(r)
        );
        const hasAnalisePlus = this.locals.accountingEntity?.props.plan
            ?.analysisPlus;

        const analysisPlusAccounting = this.locals?.analysisPlusAccounting || {
            limitCompanies: hasAnalisePlus?.limit,
            countCompanies: hasAnalisePlus?.companies?.length
        };

        this.analysisPlusCount = {
            maxCompanies: analysisPlusAccounting?.limitCompanies || 0,
            currentCompanies: analysisPlusAccounting?.countCompanies || 0
        };

        if (
            this.analysisPlusCount.currentCompanies >=
                this.analysisPlusCount.maxCompanies &&
            isAdmin
        ) {
            this.buttonText = this.optionsButton.requestLicence;
        } else {
            this.buttonText = this.optionsButton.activate;
        }
    }

    _verifyAnalysisPlus() {
        if (!this.locals.accountingEntity.hasAccountingAnalysisPlus()) {
            this.buttonText = this.optionsButton.requestLicence;
        } else if (!this.locals.accountingEntity.hasCompanyAnalysisPlus()) {
            this.buttonText = this.optionsButton.activate;
        }
    }

    async request() {
        this.$mdDialog.hide();
        const analysisPlusAccounting = await this.RequestAnalysisPlus.getAnalysisPlusLicences(
            this.locals.accountingEntity.props._id
        );
        const isAdmin = this.user.roles.some((r) =>
            [
                "Contabilidade",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads"
            ].includes(r)
        );
        if (this.locals.accountingEntity.hasAccountingAnalysisPlus()) {
            if (!isAdmin) {
                this.onActivateLicensesAnalysisPlus(
                    analysisPlusAccounting,
                    this.locals.accountingEntity.hasAccountingAnalysisPlus(),
                    true
                );
            } else {
                if (
                    this.analysisPlusCount.currentCompanies >=
                    this.analysisPlusCount.maxCompanies
                ) {
                    this.onRequestLicencesDialog(
                        this.locals.accountingEntity,
                        this.user
                    );
                } else {
                    this.RequestAnalysisPlus.onActivateAnalysisPlus(
                        this.locals.accountingEntity,
                        this.locals.companyData,
                        this.locals.callback
                    );
                }
            }
        } else {
            if (!isAdmin) {
                this.onActivateLicensesAnalysisPlus(
                    analysisPlusAccounting,
                    this.locals.accountingEntity.hasAccountingAnalysisPlus()
                );
            } else {
                this.onRequestLicencesDialog(
                    this.locals.accountingEntity,
                    this.user
                );
            }
        }
    }

    onActivateLicensesAnalysisPlus(
        analysisPlus,
        status,
        isAnalysisPlus = false
    ) {
        this.DSNDialogService.custom({
            clickOutsideToClose: true,
            controller: "ActivateAnalysisPlusDialoWarngCtrl",
            controllerAs: "$ctrl",
            locals: {
                hasAccountingAnalysisPlus: status,
                hasAnalaysisPlus: isAnalysisPlus,
                analysisPlus,
                width: "517px",
                title: "Ativar licenças Análise Plus",
                templateHtml: activateAnalysisPlusDialogTemplate
            },
            after: {
                hide: () => {}
            }
        });
    }

    onRequestConfirmAnalysisPlus(analysisPlus) {
        this.DSNDialogService.custom({
            clickOutsideToClose: true,
            controller: "RequestConfirmAnalysisPlusDialogCtrl",
            controllerAs: "$ctrl",
            locals: {
                analysisPlus,
                width: "517px",
                title: "Ativar licenças Análise Plus",
                templateHtml: requestConfirmAnalysisPlusDialogTemplate
            },
            after: {
                hide: () => {
                    this.onRequestLicencesDialog(
                        this.locals.accountingEntity,
                        this.user
                    );
                }
            }
        });
    }

    onRequestLicencesDialog(accountingEntity, user) {
        this.DSNDialogService.custom({
            clickOutsideToClose: true,
            controller: "RequestLicensesDialogCtrl",
            controllerAs: "$ctrl",
            locals: {
                accountingEntity,
                user,
                templateHtml: requestLicensesDialogTemplate
            },
            after: {}
        });
    }

    onApplyLicenses() {
        this.DSNDialogService.custom({
            controller: "ApplyLicensesDialogCtrl",
            controllerAs: "$ctrl",
            locals: {
                width: "517px",
                templateHtml: applyLicensesDialogTemplate,
                title: "Ativar licenças Análise Plus"
            },
            after: {
                hide: () => {}
            }
        });
    }
}

AnalysisPlusDialogCtrl.$inject = [
    "$mdDialog",
    "DSNDialogService",
    "locals",
    "toast"
];

angular
    .module("nucont.accounting.company.dashboards")
    .controller("AnalysisPlusDialogCtrl", AnalysisPlusDialogCtrl);
